import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Auth0Provider } from '@auth0/auth0-react';
import { auth0AudienceId, auth0ClientId, auth0Domain } from './helpers/config';
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <Auth0Provider
                    domain={auth0Domain}
                    clientId={auth0ClientId}
                    authorizationParams={{
                        redirect_uri: window.location.origin,
                        audience: auth0AudienceId
                    }}>
                    <App />
                </Auth0Provider>
            </BrowserRouter>
        </QueryClientProvider>
    </React.StrictMode>
);

reportWebVitals();